<template>
  <div>
    <div v-if="!pod">
      File not found!
    </div>

    <div v-if="pod">

      <div class="d-flex" :class="$vuetify.display.xs ? 'flex-column' : ''">
        <div class="flex-grow-1 d-flex align-center">
          <h1>{{$t('routes.pod.labels')}}</h1>
        </div>

        <div class="text-right">
          <v-btn
            v-if="$canRunPaidService() && $canLabelPods() && (isVideoPod || isImagePod)"
            @click="showingLabelSelectedDialog = true"
            :pods="selectedPods"
            class="mr-2"
            color="primary"
            elevation=0
          >
            <v-icon>mdi-tag</v-icon>
            {{ $t('routes.pod.detectLabelsToolbar') }}
          </v-btn>

          <v-btn color="primary" elevation=0 @click="showingExportFCPXMLDialog = true">
            <v-icon>mdi-file-export</v-icon>
            {{ $t('routes.pod.menuLabelsAndMetadata.exportFCPXML') }}
          </v-btn>
        </div>
      </div>

      <div>
        <!-- <v-select
          v-bind:label="$t('routes.pod.menuEditLabels.sources')"
          v-model="selectedSource"
          v-bind:rules="selectedSourceRules"
          v-bind:items="sources"
          v-on:change="updateSelectedLayer"
          item-text="name"
          item-value="id"
          required
          single-line
        ></v-select> -->

        <v-radio-group
          v-model="selectedSource"
          @update:model-value="updateSelectedLayer"
          hide-details
          mandatory
          class="mb-4"
        >

          <v-radio
            v-for="source in sources"
            :key="source.id"
            :label="source.name"
            :value="source.id"
            :data-cy="`podMenu-labels-source-${source.id}`">
          </v-radio>
        </v-radio-group>
      </div>

      <!-- ML labels options starts -->
      <v-expansion-panels
        v-if="isMlLabelSelected"
        v-model="optionsPanelExpanded"
        variant="accordion"
        class="pod-labels-options mb-4"
      >
        <v-expansion-panel rounded="10" bg-color="list">
          <v-expansion-panel-title color="secondaryButtons">
            {{ $t('menus.uploadFiles.options') }}
          </v-expansion-panel-title>
          <v-expansion-panel-text class="py-1" >
            <div v-show="selectedSource === 'amazon-text-source'" class="d-flex justify-center">
              <v-radio-group
                v-model="mlShowType"
                @update:modelValue="layersOptionsChanged"
                density="compact"
                class="mt-0 pt-0 mb-2 flex-0-0"
                :disabled="selectedSource === 'amazon-labels-source'"
                inline
                hide-details
              >
                <v-radio
                  v-bind:label="$t('routes.pod.menuEditLabels.showLines')"
                  density="comfortable"
                  value="lines"
                />
                <v-radio
                  v-bind:label="$t('routes.pod.menuEditLabels.showWords')"
                  density="comfortable"
                  value="words"
                />
                <v-radio
                  v-bind:label="$t('routes.pod.menuEditLabels.showBoth')"
                  density="comfortable"
                  value="both"
                />
              </v-radio-group>
            </div>

            <div
              v-if="selectedSource === 'amazon-text-source' || selectedSource === 'amazon-labels-source'"
              class="d-flex">
              <div class="text-right" style="width: 50%; padding-top: 10px; padding-right: 20px;">
                {{ $t('routes.pod.menuEditLabels.confidenceLevel') }}
              </div>
              <div class="" style="width: 50%;">
                <v-text-field
                  type="number"
                  v-model.number="confidenceLevel"
                  v-bind:disabled="false"
                  v-on:blur="confidenceFocusOut"
                  v-bind:rules="confidenceLevelRules"
                  width="100%"
                  max="100" min="0"
                  required density="compact"
                  variant="solo-filled"
                  flat hide-details
                  data-cy="podMenu-labels-------"
                />
              </div>
            </div>

            <div
              v-if="(selectedSource == 'amazon-text-source' || selectedSource == 'amazon-labels-source') && isVideoPod "
              class="d-flex flex-row">
              <div class="flex-grow-1 d-flex justify-center">
                <v-checkbox
                  v-model="showLabelsOnLayer"
                  v-bind:label="$t('routes.pod.menuEditLabels.showTextLabels')"
                  v-on:update:model-value="layersOptionsChanged"
                  hide-details
                >
                </v-checkbox>
              </div>

              <div class="flex-grow-1 d-flex justify-center">
                <v-checkbox
                  v-model="showRectOnLayer"
                  v-bind:label="$t('routes.pod.menuEditLabels.showRectangles')"
                  v-on:update:model-value="layersOptionsChanged"
                  hide-details
                >
                </v-checkbox>
              </div>
            </div>

          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- ML labels options ends -->

      <div v-if="!openEditForm && !isMlLabelSelected && $canLabelPods()" class="mb-4 d-flex align-items-center">
        <v-btn @click="openEditForm = true" elevation=0 color="primary" class="mr-4">
          <v-icon>mdi-tag-plus</v-icon>
          {{$t('routes.pod.menuEditLabels.addLabel')}}
        </v-btn>

        <div class="flex-grow-1"></div>

        <v-btn v-if="$canLabelPods()" elevation=0 color="primary" @click="openSelectCustomLabelsDialog = true">
          <v-icon>mdi-format-list-bulleted</v-icon>
          {{ $t('routes.pod.menuEditLabels.predefinedLabels') }}
        </v-btn>
      </div>

      <PodEditLabelForm
        v-show="$canLabelPods() && (openEditForm || editItem)"
        v-model:editItem="editItem"
        :pod="pod"
        :isMlLabel="isMlLabelSelected"
        @closeForm="closeForm()"
        data-cy="podMenu-labels-form"
      />

      <PodCustomLabelsList
        v-if="selectedSource === 'custom-source'"
        v-model="chipsModel"
        v-bind:pod="pod"
        v-model:labelsArray="getCustomLabels"
        v-on:setEditItem="setEditItem"
        class=""
        data-cy="podMenu-labels-labelList"
      />

      <PodMlLabelsList
        v-if="selectedSource === 'amazon-text-source' || selectedSource === 'amazon-labels-source'"
        v-model="chipsModel"
        v-bind:pod="pod"
        v-model:labelsArray="getFilteredMLLabels"
        v-bind:mlShowType="mlShowType"
        v-bind:confidenceLevel="confidenceLevel"
        v-bind:disableTypeFilter="selectedSource === 'amazon-labels-source'"
        v-bind:disableEditing="selectedSource === 'amazon-labels-source'"
        v-on:setEditItem="setEditItem"
        class=""
        data-cy="podMenu-labels-generatedLabelList"
      />

      <LabelSelectedDialog
        v-if="$canRunPaidService() && (isVideoPod || isImagePod)"
        v-model="showingLabelSelectedDialog"
        :pods="[pod]"
      />

      <ExportFCPXMLDialog
        v-model="showingExportFCPXMLDialog"
      />

      <SelectLabelsDialog
        v-if="$canLabelPods()"
        v-model="openSelectCustomLabelsDialog"
        :is-processing-labels="isProcessingCustomLabels"
        :podId="pod.id"
        :show-custom-labels="false"
        @addLabels="addLabels"
      />
    </div>
  </div>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { usePlayerStore } from '@/stores/PlayerStore.js';
import { usePodLabelStore } from '@/stores/PodLabelStore.js';
import LabelSelectedDialog from '@/routes/pods2/components/dialogs/LabelSelectedDialog.vue';
import SelectLabelsDialog from '@/routes/pods2/components/dialogs/SelectLabelsDialog.vue';
import PodCustomLabelsList from './PodCustomLabelsList.vue';
import PodMlLabelsList from './PodMlLabelsList.vue';
import PodEditLabelForm from './PodEditLabelForm.vue';
import ExportFCPXMLDialog from './ExportFCPXMLDialog.vue';

export default {
  name: "LabelsToolbar",
  components: {
    LabelSelectedDialog,
    PodCustomLabelsList,
    PodMlLabelsList,
    PodEditLabelForm,
    ExportFCPXMLDialog,
    SelectLabelsDialog
  },
  data() {
    return {
      editItem: null,
      chipsModel: null,
      openEditForm: false,
      openSelectCustomLabelsDialog: false,
      showingLabelSelectedDialog: false,
      showingExportFCPXMLDialog: false,
      isProcessingCustomLabels: false,

      selectedSource: 'custom-source',
      selectedSourceRules: [
        v => !!v || this.$t('routes.pod.menuEditLabels.sourceRequired'),
      ],

      mlShowType: 'both',
      confidenceLevel: 90,
      confidenceLevelRules: [
        // v => v.match(/^\d{1,3}$/gmi),
      ],

      showLabelsOnLayer: true,
      showRectOnLayer: true,

      pendingHighlightTime: null,
      selectedLabel: null,

      initializedFromUrl: false,
      optionsPanelExpanded: null,
    };
  },
  mounted() {
    if (!this.pod) {
      return;
    }

    // First load stashed controls
    this.setControlsFromStash();

    // Now check URL parameters
    this.handleUrlParameters();

    // Mark the component as having processed URL params initially
    this.initializedFromUrl = true;
  },
  watch: {
    getActiveLayer: function(newLayerID) {
      if (newLayerID == 2 && this.getAmazonDetectedTexts) {
        this.selectedSource = 'amazon-text-source';
      }

      if (newLayerID == 3 && this.getAmazonDetectedLabels) {
        this.selectedSource = 'amazon-labels-source';
      }
    },

    sources: {
      handler(newSources) {
        // If we have sources and query parameters, handle URL parameters
        if (newSources.length > 0 && this.$route.query.type) {
          this.handleUrlParameters();
        }
      },
      immediate: true,
      deep: true
    },

    getFilteredMLLabels: {
      handler(newLabels) {
        if (newLabels && newLabels.length > 0 && this.pendingHighlightTime !== null) {
          this.highlightLabelByTime(this.pendingHighlightTime);
          this.pendingHighlightTime = null;
        }
      },
      deep: true
    },

    selectedSource: {
      handler(newSource) {
        // Only close form and reset controls if not initializing from URL
        if (this.initializedFromUrl) {
          this.closeForm();
          this.setControlsFromStash();

          // Auto-expand options panel for ML sources
          if ((newSource === 'amazon-labels-source' || newSource === 'amazon-text-source') &&
              this.$route.query.type) {
            this.optionsPanelExpanded = 0;
          }

          this.layersOptionsChanged();
        }

        // If we have a pending highlight time, wait for labels to be loaded
        if (this.pendingHighlightTime && this.getFilteredMLLabels && this.getFilteredMLLabels.length > 0) {
          // Use setTimeout to ensure this runs after Vue has updated the DOM
          setTimeout(() => {
            this.highlightLabelByTime(this.pendingHighlightTime);
          }, 300);
        }
      }
    },

    '$route': {
      handler(newRoute) {
        if (newRoute.query.menu === 'labels') {
          const queryType = newRoute.query.type;
          const queryStartTime = newRoute.query.start ? parseInt(newRoute.query.start) : null;

          if (queryType) {
            if (queryType.includes('text') && this.selectedSource !== 'amazon-text-source') {
              this.selectedSource = 'amazon-text-source';
              this.confidenceLevel = 0;

              // Only change mlShowType if explicitly specified
              if (queryType.includes('words')) {
                this.mlShowType = 'words';
              } else if (queryType.includes('lines')) {
                this.mlShowType = 'lines';
              }
              // Default will remain as 'both'

              this.optionsPanelExpanded = 0; // Auto-expand options
              this.updateSelectedLayer();
              this.layersOptionsChanged();
            } else if (queryType.includes('label') && this.selectedSource !== 'amazon-labels-source') {
              this.selectedSource = 'amazon-labels-source';
              this.confidenceLevel = 0;
              this.optionsPanelExpanded = 0; // Auto-expand options
              this.updateSelectedLayer();
              this.layersOptionsChanged();
            }
          }

          if (queryStartTime) {
            this.pendingHighlightTime = queryStartTime;

            // If we have labels already, try to highlight
            if (this.getFilteredMLLabels && this.getFilteredMLLabels.length > 0) {
              setTimeout(() => {
                this.highlightLabelByTime(queryStartTime);
              }, 300);
            }
          }
        }
      },
      deep: true
    },
  },
  methods: {
    closeForm: function() {
      this.editItem = null;
      this.chipsModel = null;
      this.openEditForm = false;
    },
    setEditItem: function(item) {
      if (this.editItem && this.editItem.id === item.id) {
        // If we're selecting the same item, just scroll to it
        this.scrollToLabel(item.id);
        return;
      } else {
        this.editItem = item;
        this.openEditForm = true;

        // Scroll to the selected item after setting it as active
        this.$nextTick(() => {
          this.scrollToLabel(item.id);
        });
      }
    },
    confidenceFocusOut: function() {
      this.confidenceLevel = Number(this.confidenceLevel);
      if (isNaN(this.confidenceLevel) || this.confidenceLevel > 100 || this.confidenceLevel == "") {
        this.confidenceLevel = 100;
      } else if (this.confidenceLevel < 0) {
        this.confidenceLevel = 0;
      }

      this.layersOptionsChanged();
    },
    layersOptionsChanged: function() {
      let optionsName = 'AWSDETECTEDTEXT';
      if (this.selectedSource === 'amazon-labels-source') {
        optionsName = 'AWSDETECTEDLABELS';
      }

      // Create options object for BOTH sources
      const options = {};

      // Always set options for text source
      options[optionsName] = {
        showLabelsOnLayer: this.showLabelsOnLayer,
        showRectOnLayer: this.showRectOnLayer,
        filterByType: this.mlShowType,
        confidenceLevel: this.confidenceLevel,
      };

      // Always set options for labels source
      options[optionsName] = {
        showLabelsOnLayer: this.showLabelsOnLayer,
        showRectOnLayer: this.showRectOnLayer,
        filterByType: 'both', // Always use 'both' for labels
        confidenceLevel: this.confidenceLevel,
      };

      const playerStore = usePlayerStore();
      playerStore.setLayersOptions(options);
    },

    updateSelectedLayer: function() {
      const playerStore = usePlayerStore();

      switch (this.selectedSource) {
        case 'amazon-text-source': playerStore.setActiveLayer(2); break;
        case 'amazon-labels-source': playerStore.setActiveLayer(3); break;
        default: playerStore.setActiveLayer(0); break;
      }
    },
    setControlsFromStash: function() {
      const playerStore = usePlayerStore();
      const options = playerStore.getLayersOptions;

      switch (this.selectedSource) {
        case 'amazon-text-source': this.setControlsForAWSDETECTEDTEXT(options); break;
        case 'amazon-labels-source': this.setControlsForAWSDETECTEDLABELS(options); break;
        default: this.setControlsForAWSDETECTEDTEXT(options);
      }
    },
    setControlsForAWSDETECTEDTEXT: function(options) {
      if (typeof options.AWSDETECTEDTEXT.showLabelsOnLayer == 'boolean') {
        this.showLabelsOnLayer = options.AWSDETECTEDTEXT.showLabelsOnLayer;
      }
      if (typeof options.AWSDETECTEDTEXT.showRectOnLayer == 'boolean') {
        this.showRectOnLayer = options.AWSDETECTEDTEXT.showRectOnLayer;
      }
      if (typeof options.AWSDETECTEDTEXT.filterByType == 'string') {
        this.mlShowType = options.AWSDETECTEDTEXT.filterByType;
      }
      if (typeof options.AWSDETECTEDTEXT.confidenceLevel == 'number') {
        this.confidenceLevel = options.AWSDETECTEDTEXT.confidenceLevel;
      }
    },
    setControlsForAWSDETECTEDLABELS: function(options) {
      if (typeof options.AWSDETECTEDLABELS.showLabelsOnLayer == 'boolean') {
        this.showLabelsOnLayer = options.AWSDETECTEDLABELS.showLabelsOnLayer;
      }
      if (typeof options.AWSDETECTEDLABELS.showRectOnLayer == 'boolean') {
        this.showRectOnLayer = options.AWSDETECTEDLABELS.showRectOnLayer;
      }
      if (typeof options.AWSDETECTEDLABELS.confidenceLevel == 'number') {
        this.confidenceLevel = options.AWSDETECTEDLABELS.confidenceLevel;
      }
    },
    addLabels: async function (payload) {
      const { labels } = payload;
      console.log('Adding labels:', labels);

      const customLabels = this.getCustomLabels;

      // filter out the labels that are already in the custom labels
      const selectedLabels = labels.filter((label) => {
        return !customLabels.some((customLabel) => customLabel.content === label);
      });

      // if all the labels are already in the custom labels, show an error message.
      if (selectedLabels.length === 0) {
        this.$showMessage(this.$t('routes.labels.labelsAlreadyExists'), { type: 'error' });
        return;
      }

      const podLabelStore = usePodLabelStore();
      this.isProcessingCustomLabels = true;

      try {
        await podLabelStore.createLabels({
          podids: [this.pod.id],
          labels,
        });

        this.openSelectCustomLabelsDialog = false;

        this.$showMessage(this.$t('routes.pod.labelsAdded', labels.length), { type: 'success' });
      } catch (error) {
        const apiError = error?.response?.data?.error;

        if (apiError) {
          const localizedError = this.$localizeMessage(apiError, this.$t('common.generalError'));
          this.$showMessage(localizedError, { type: 'error' });
        } else {
          console.log(apiError.message);
        }
      } finally {
        this.isProcessingCustomLabels = false;
      }
    },
    highlightLabelByTime(startTime) {
      const timeInMs = parseInt(startTime);
      let matchingLabel = null;

      // Look for a label with the matching start time
      if (this.getFilteredMLLabels && this.getFilteredMLLabels.length) {
        // Try several properties since the data structure might vary
        matchingLabel = this.getFilteredMLLabels.find(
            (label) => {
              return (
                  label.time === timeInMs ||
                  label.startTime === timeInMs ||
                  label.start === timeInMs ||
                  (label.start <= timeInMs && label.end > timeInMs)
              );
            }
        );
      }

      if (matchingLabel) {
        // Store the selected label
        this.selectedLabel = matchingLabel;

        // Set as edit item to highlight it
        this.setEditItem(matchingLabel);

        // If this is a video pod, seek to the correct time
        if (this.isVideoPod) {
          const seekTime = matchingLabel.start || matchingLabel.startTime || matchingLabel.time;
          if (seekTime !== undefined) {
            const playerStore = usePlayerStore();
            playerStore.setSeekTimeEvent(seekTime / 1000); // Convert to seconds
          }
        }
      }
    },

    scrollToLabel(labelId) {
      // Give the DOM time to update before attempting to scroll
      this.$nextTick(() => {
        // Try multiple selector strategies to find the element
        let labelElement = document.querySelector(`[data-label-id="${labelId}"]`);

        // If not found by data-label-id, try by class with ID
        if (!labelElement) {
          labelElement = document.querySelector(`.label-item-${labelId}`);
        }

        // If not found by class, try by ref
        if (!labelElement && this.$refs[`label${labelId}`]) {
          if (Array.isArray(this.$refs[`label${labelId}`])) {
            labelElement = this.$refs[`label${labelId}`][0];
          } else {
            labelElement = this.$refs[`label${labelId}`];
          }
        }

        // If element found, scroll to it
        if (labelElement) {
          labelElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          // Add a temporary highlight class to make it more visible
          labelElement.classList.add('highlight-active-label');
          setTimeout(() => {
            labelElement.classList.remove('highlight-active-label');
          }, 2000);
        }
      });
    },

    handleUrlParameters() {
      const queryType = this.$route.query.type;
      const queryStartTime = this.$route.query.start ? parseInt(this.$route.query.start) : null;
      const queryMenu = this.$route.query.menu;

      if (queryMenu === 'labels' && queryType) {
        // Check if sources are available
        if (this.sources.length > 0) {
          // Set the radio button and options based on type parameter
          if (queryType.includes('text') && this.sources.some(s => s.id === 'amazon-text-source')) {
            this.selectedSource = 'amazon-text-source';
            this.confidenceLevel = 0; // Set confidence level to 0 for text

            // Only change mlShowType if explicitly specified in URL
            if (queryType.includes('words')) {
              this.mlShowType = 'words';
            } else if (queryType.includes('lines')) {
              this.mlShowType = 'lines';
            }
            // Otherwise leave as default ('both')

            // Auto-expand the options panel
            this.optionsPanelExpanded = 0;

            // Wait for next tick to ensure component updates
            this.$nextTick(() => {
              this.updateSelectedLayer();
              this.layersOptionsChanged();
            });
          } else if (queryType.includes('label') && this.sources.some(s => s.id === 'amazon-labels-source')) {
            this.selectedSource = 'amazon-labels-source';
            this.confidenceLevel = 0; // Set confidence level to 0 for label
            // Auto-expand the options panel
            this.optionsPanelExpanded = 0;

            // Wait for next tick to ensure component updates
            this.$nextTick(() => {
              this.updateSelectedLayer();
              this.layersOptionsChanged();
            });
          }

          // Store the start time for highlighting
          if (queryStartTime) {
            this.pendingHighlightTime = queryStartTime;

            // Try highlighting if labels are loaded
            setTimeout(() => {
              if (this.getFilteredMLLabels && this.getFilteredMLLabels.length > 0) {
                this.highlightLabelByTime(this.pendingHighlightTime);
              }
            }, 300);
          }
        }
      }
      // Fall back to service parameter if type isn't specified
      else if (this.sources.length > 0) {
        const queryService = this.$route.query.service;
        if (queryService) {
          if (queryService === 'aws-detecting-labels' &&
              this.sources.some(s => s.id === 'amazon-labels-source')) {
            this.selectedSource = 'amazon-labels-source';
            this.updateSelectedLayer();
            this.layersOptionsChanged();
          } else if (queryService === 'aws-detecting-text' &&
              this.sources.some(s => s.id === 'amazon-text-source')) {
            this.selectedSource = 'amazon-text-source';
            this.updateSelectedLayer();
            this.layersOptionsChanged();
          }
        }
      }
    },
  },
  computed: {
    pod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    isVideoPod: function() {
      const podStore = usePodStore();
      return podStore.isVideoPod;
    },
    isImagePod: function() {
      const podStore = usePodStore();
      return podStore.isImagePod;
    },

    getCustomLabels: function() {
      const podLabelStore = usePodLabelStore();
      return podLabelStore.getLabels;
    },

    getMlLabels: function() {
      const podLabelStore = usePodLabelStore();
      return podLabelStore.getMlLabels;
    },
    getFilteredMLLabels: function() {
      switch (this.selectedSource) {
        case 'amazon-text-source': return this.getAmazonDetectedTexts;
        case 'amazon-labels-source': return this.getAmazonDetectedLabels;
        default: return [];
      }
    },
    sources: function() {
      let services = [];
      services.push(this.getCustomSourceItem);

      if (this.getAmazonDetectedTexts && this.getAmazonDetectedTexts.length) {
        services.push(this.getAmazonTextSource);
      }

      if (this.getAmazonDetectedLabels && this.getAmazonDetectedLabels.length) {
        services.push(this.getAmazonLabelsSource);
      }

      return services;
    },
    getCustomSourceItem: function() {
      return {
        id: 'custom-source',
        name: this.$t('routes.pod.menuEditLabels.predefinedLabels')
      };
    },
    getAmazonTextSource: function() {
      return {
        id: 'amazon-text-source',
        name: this.$t('routes.pod.menuEditLabels.amazonDetectedText')
      };
    },
    getAmazonLabelsSource: function() {
      return {
        id: 'amazon-labels-source',
        name: this.$t('routes.pod.menuEditLabels.amazonDetectedLabels')
      };
    },
    getAmazonDetectedTexts: function() {
      // filter the ML labels by service 'aws-detecting-text'
      return this.getMlLabels.filter(x => x.service === 'aws-detecting-text');
    },
    getAmazonDetectedLabels: function() {
      // filter the ML labels by service 'aws-detecting-labels'
      return this.getMlLabels.filter(x => x.service === 'aws-detecting-labels');
    },
    isMlLabelSelected: function() {
      return this.selectedSource == 'amazon-text-source' ||
             this.selectedSource == 'amazon-labels-source';
    },
    getActiveLayer: function() {
      const playerStore = usePlayerStore();
      return playerStore.getActiveLayer;
    },
    selectedPods: function() {
      return [this.pod];
    },
  }
}
</script>

<style>
.pod-labels-options button.v-expansion-panel-header {
  border-radius: 10px;
}

.pod-labels-table { width: 100%; line-height: 1.2; border-collapse: collapse; }
.pod-labels-table > thead { background-color: #3dabff; border-radius: 8px; }
.pod-labels-table > thead > tr > td { font-weight: 600; color: #333333; padding: 8px;}
.pod-labels-table > thead > tr > td:first-child {
  border: 0px solid #3dabff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.pod-labels-table > thead > tr > td:last-child {
  border: 0px solid #3dabff;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.pod-labels-table > thead > tr > td:nth-child(1),
.pod-labels-table > tbody > tr > td:nth-child(1) { width: 20%;}
.pod-labels-table > thead > tr > td:nth-child(2),
.pod-labels-table > tbody > tr > td:nth-child(2) { width: 15%; text-align: center;}
.pod-labels-table > thead > tr > td:nth-child(3),
.pod-labels-table > tbody > tr > td:nth-child(3) { width: 65%;}

.v-theme--light .pod-labels-table > tbody > tr { background-color: #e6ecf1; border-bottom: 2px solid #FFFFFF;}
.v-theme--dark .pod-labels-table > tbody > tr { background-color: #2f3640; border-bottom: 2px solid #232b36;}
.pod-labels-table > tbody > tr > td { padding: 8px 8px; }
.pod-labels-table > tbody > tr > td:first-child {
  border: 0px solid #3dabff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pod-labels-table > tbody > tr > td:last-child {
  border: 0px solid #3dabff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.pod-labels-table > tbody > tr.active-subtitle { color: #3dabff; }
.pod-labels-table > tbody > tr > td > .pod-subtitle-warning { color: #ff8282; }

.labels-chevron {float:right;}

@keyframes highlight-pulse {
  0% { background-color: rgba(61, 171, 255, 0.1); }
  50% { background-color: rgba(61, 171, 255, 0.3); }
  100% { background-color: rgba(61, 171, 255, 0.1); }
}

.highlight-active-label {
  animation: highlight-pulse 2s ease-in-out;
  border-left: 3px solid #3dabff !important;
}

.theme--dark .highlight-active-label {
  animation: highlight-pulse 2s ease-in-out;
  border-left: 3px solid #3dabff !important;
}
</style>
